import { Toast } from 'bootstrap';
//import * as bootstrap from 'bootstrap'
//import jquery from 'jquery';
import $ from './shims/jquery-shim.js';
import './lib/lavish-template.js';
import LavishTemplate from './lib/lavish-template.js';

class MainApp {
    constructor() {
        this.init();
    }

    init() {
      const lavish = new LavishTemplate();
      this.initToast();

      //console.log('jQuery version:', $)
    }

    initToast() {
      const toastElList = document.querySelectorAll('.toast')
      const option = {}
      const toastList = [...toastElList].map(toastEl => {
        const newToast = new Toast(toastEl, option)
        newToast.show()
      })
    }
}

// Initialize the app when document is ready
$(function() {
  try {
    const app = new MainApp();
  } catch (error) {
    console.error('Failed to initialize app:', error);
  }
});
